import api from './api';
import {
  SchedulerJob,
  SchedulerStatus,
  SchedulerLogsResponse,
  ToggleAutoRunDto
} from '../types/scheduler.ts';
import { unwrapApiResponse } from '@/utils/api-response.util';

class SchedulerService {
  private readonly BASE_URL = '/scheduler';

  async getJobs(): Promise<SchedulerJob[]> {
    const response = await api.get<SchedulerJob[]>(`${this.BASE_URL}/jobs`);
    return unwrapApiResponse<SchedulerJob[]>(response);
  }

  async getStatus(): Promise<SchedulerStatus> {
    const response = await api.get<SchedulerStatus>(`${this.BASE_URL}/status`);
    return unwrapApiResponse<SchedulerStatus>(response);
  }

  async toggleAutoRun(enabled: boolean): Promise<SchedulerStatus> {
    const payload: ToggleAutoRunDto = { enabled };
    const response = await api.post<SchedulerStatus>(`${this.BASE_URL}/toggle-auto-run`, payload);
    return unwrapApiResponse<SchedulerStatus>(response);
  }

  async runJob(name: string): Promise<{ message: string }> {
    const response = await api.post<{ message: string }>(`${this.BASE_URL}/run/${name}`);
    return unwrapApiResponse<{ message: string }>(response);
  }

  async getLogs(limit: number = 50, offset: number = 0): Promise<SchedulerLogsResponse> {
    const response = await api.get<SchedulerLogsResponse>(`${this.BASE_URL}/logs`, {
      params: { limit, offset }
    });
    return unwrapApiResponse<SchedulerLogsResponse>(response);
  }

  async debug(): Promise<unknown> {
    const response = await api.get<unknown>(`${this.BASE_URL}/debug`);
    return response.data;
  }
}

export const schedulerService = new SchedulerService();
